import { ValidateField, ExponentialToDecimal, FieldHasValue } from 'helpers/Validation';

export const AsLeftTestTableDeviationEu2Formula = (formData) => FieldHasValue(formData.F652asLeftTripPoint) && FieldHasValue(formData.F1056AltObservedTripSetpoint)
? ExponentialToDecimal(Math.abs(ValidateField(formData.F652asLeftTripPoint) - ValidateField(formData.F1056AltObservedTripSetpoint))) : '';
